import { MarkedOptions, MarkedRenderer } from 'ngx-markdown';

export function markedOptionsFactory(): MarkedOptions {
	const renderer = new MarkedRenderer();

	// Override link renderer to handle both old (object) and new (string) signatures
	renderer.link = (function(href: any, title?: any, text?: any): string {
		// Handle old signature: first arg is an object
		if (typeof href === 'object' && href !== null) {
			const obj = href;
			const safeHref = obj.href || obj.raw || '';
			const safeText = obj.text || safeHref;
			return `<a role="link" tabindex="0" target="_blank" href="${safeHref}">${safeText}</a>`;
		}
		// Handle new signature: href, title, text
		const safeHref = typeof href === 'string' ? href : (href?.toString?.() || '');
		const safeTitle = title ? ` title="${title}"` : '';
		let safeText = '';
		if (typeof text === 'string' && text.trim()) {
			safeText = text;
		} else if (safeHref) {
			safeText = safeHref;
		} else {
			safeText = 'link';
		}
		return `<a role="link" tabindex="0" target="_blank" href="${safeHref}"${safeTitle}>${safeText}</a>`;
	} as any);

	return {
		renderer,
		gfm: true,
		breaks: false,
		pedantic: false,
	};
}
